export default {
  project: "Westfield",
  name: "Westfield",
  url: "http://thq-westfield.s3-website-ap-southeast-2.amazonaws.com",
  auth_landing_module: "/ordering",
  idle_limit: 180000, //180000,
  // Role 5 store scoping. Key = login username (any case).
  // `field` is the order field holding the collect store; `match` must equal it
  // exactly. An account absent from this map is not scoped and sees every store.
  orderScope: {
    RiccartonCC: { field: "collectStore", match: 32280253 },
    NewmarketCC: { field: "collectStore", match: 32280254 },
  },
  // Order statuses role 5 must not see, by orderStatusId. Add ids here; no code
  // change needed. Known ids, from app-module-order-section-search/config.js:
  //   1 QUOTED   2 ONHOLD   3 DECLINED   5 ACTIVATED
  //   6 PAYMENT CONFIRMED   7 PENDING ACTIVATION   8 APPROVED
  // "Ready for Collection" and "Collected and Activated" also exist as names in
  // the C&C flow; their ids are not recorded anywhere in the frontend yet.
  hideOrderStatus: [1, 2],
  thor: {
    moduleCode: {
      production: "WGMB",
      development: "WGMB",
    },
    moduleCodeCorp: {
      production: "WSH2kdh2bcks",
      development: "WSH2kdh2bcks",
    },
    programId: null,
    products: {
      production: {
        cards: {
          red: 380172,
          hb: 724985,
          ty: 724984,
          ch: 725023,
          sb: 725130,
          rb: 725114,
        },
      },
      development: {
        cards: {
          red: 380172,
          hb: 724986,
          ty: 724985,
          ch: 725023,
          sb: 725130,
          rb: 725114,
        },
      },
    },
  },
  api: {
    westfield_auth_v1: {
      url: {
        production: "https://tr4ns10.tr4ns.com/Westfield-BulkOrder/auth",
        development: "https://tr4ns10.tr4ns.com/Westfield-BulkOrder/auth",
      },
    },
    westfield_v1: {
      url: {
        production: "https://tr4ns10.tr4ns.com/Westfield-BulkOrder",
        development: "https://tr4ns10.tr4ns.com/Westfield-BulkOrder",
      },
    },
    westfield_reporting_v1: {
      url: {
        production: "https://tr4ns10.tr4ns.com",
        development: "https://tr4ns10.tr4ns.com",
      },
    },
    tranxactor_westfield_corp: {
      url: {
        production: "https://tr4ns10.tr4ns.com/Westfield-Corporate",
        development: "https://tr4ns10.tr4ns.com/Westfield-Corporate",
      },
    },
  },
};
